import { getContentWarnings } from 'catalog/plugin';

export const pageComparator = (p1, p2) => {
  if (p1.isRoot) return -1;
  if (p2.isRoot) return 1;

  if (p1.isLocked || p1.template.isLocked) return -1;
  if (p2.isLocked || p2.template.isLocked) return 1;

  const p1Name = p1.name.toLowerCase();
  const p2Name = p2.name.toLowerCase();

  return p1Name < p2Name ? -1 : +(p1Name > p2Name);
};

export const isPageLocked = page =>
  page.isRoot || page.isLocked || page.template.isLocked;

/**
 * Accumulates warning relative to this page
 */
export const getPageWarnings = (
  page: CatalogPage,
  content: CatalogPageContent
): Array<string> => {
  return getContentWarnings(page.template.code, content);
};



// WEBPACK FOOTER //
// ./src/modules/catalog/reducers/page.js